/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Washer } from "./modelWasher";

class ControllerWasher extends ControllerModel {
    constructor() {
        super("ControllerWasher");

        this.setNewNode = (callback) => {
            let washer = new Washer();
            washer.decorate(callback);

            this.addNode(washer);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let washer = new Washer();
            washer.copyFrom(node);
            washer.decorate(callback);
            this.addNode(washer)
        }

        this.getProperties = async (node) => {
            let n = new Washer();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new Washer();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerWasher };